import React from "react"
import { css } from "emotion"
import ConnectedUsers from "./ConnectedUsers"
import * as SocketIOClient from "socket.io-client"
import type { User } from "../types"

export interface ToolbarProps {
	connectedUsers: User[]
	showUserSettingsModal: () => void
	sockets: SocketIOClient.Socket
}

export default function Toolbar(props: ToolbarProps) {
	return (
		<div
			className={css`
				display: flex;
				flex-direction: row;
				align-items: center;
				position: fixed;
				z-index: 999999;
				bottom: 2.25rem;
				right: 5.5rem;
				margin-right: 20px;
				height: 50px;
			`}
		>
			{props.connectedUsers.length > 0 && (
				<div
					className={css`
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
						width: fit-content;
						min-width: 110px;
						max-width: 95%;
						border-radius: 70px;
						box-sizing: border-box;
						height: 50px;
						padding: 0px 10px;

						@media screen and (max-width: 450px) {
							margin-left: auto;
							margin-right: auto;
							left: 0 !important;
							right: 0;
						}
					`}
				>
					<div
						className={css`
							padding: 0 0.5rem;
							height: 100%;
							display: flex;
							align-items: center;
						`}
					>
						<ConnectedUsers
							connectedUsers={props.connectedUsers}
							onOpenUserSettings={props.showUserSettingsModal}
							socket={props.sockets}
						/>
					</div>
				</div>
			)}
		</div>
	)
}
